import { RouterView } from "vue-router";
import { ProjectTypeRouting } from "./project-type/project-type.routing";

export const ProjectConfigRouting = {
  path: "/project-config",
  name: "project-config",
  redirect: "/project-config/project-type/list",
  component: RouterView,
  meta: { title: "项目管理", icon: "xiangmu2" },
  children: [...ProjectTypeRouting],
};
